import { Injectable } from '@angular/core';

import { Observable, catchError } from 'rxjs';

import { ApiTemplate, ApiResponse, RequestOptions, TemplateHelper } from '../base';
import { AccountRequest, AccountResponse } from './model/account.model';

@Injectable({ providedIn: 'root' })
export class AuthorizationAccountApi extends ApiTemplate<AccountResponse, AccountRequest> {
    constructor() {
        super('http.rest.auth.url', '/api/accounts');
    }

    createAccount(payload: AccountRequest, options?: RequestOptions): Observable<ApiResponse<AccountResponse>> {
        return this.create(payload, options);
    }

    findAccountByUsername(username: string, options?: RequestOptions): Observable<ApiResponse<AccountResponse>> {
        return this.getByPath(username, options);
    }

    resetAccount(id: number, options?: RequestOptions): Observable<void> {
        return this.putAction(`${id}/reset`, options);
    }

    enableAccountOtp(id: number, options?: RequestOptions): Observable<void> {
        return this.putAction(`${id}/otp/enable`, options);
    }

    requestAccountPasswordChange(id: number, options?: RequestOptions): Observable<void> {
        return this.putAction(`${id}/password/request-change`, options);
    }

    updateAccountLanguage(id: number, langCode: string, options?: RequestOptions): Observable<void> {
        return this.putAction(`${id}/language/${langCode}`, options);
    }

    private putAction(path: string, options?: RequestOptions): Observable<void> {
        const url = this.urlBuilder!.build(path);
        const httpOptions = TemplateHelper.buildOptions(options);

        return this.http
            .put<void>(url, null, httpOptions)
            .pipe(
                TemplateHelper.applyRetry(options),
                catchError((err) => TemplateHelper.handleError(err))
            );
    }
}
